/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { ControllerLib, ControllerLibInterface } from "../ControllerLib";

const _abi = [
  {
    inputs: [],
    name: "HERO_PAYMENT_DENOMINATOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "HERO_PAYMENT_PART_BOSS_REWARDS_POOL",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "HERO_PAYMENT_PART_TREASURY_LAST_BIOME",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class ControllerLib__factory {
  static readonly abi = _abi;
  static createInterface(): ControllerLibInterface {
    return new Interface(_abi) as ControllerLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ControllerLib {
    return new Contract(address, _abi, runner) as unknown as ControllerLib;
  }
}
